export enum DefaultParameterSetting {
    MENTAL_HEALTH_DIAGNOSIS = 8,
}